import React, { useState, useEffect, useContext } from "react";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import "./questionReport.css";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
import getQuestionReportResponse from "../../apis/questionReport/getQuestionReports";
import updateQuestionReportResponse from "../../apis/questionReport/updateQuestionReport";

import TextareaAutosize from '@mui/material/TextareaAutosize';
import { DateTime } from "luxon";
import { UserTypeContext } from "../../AppRoute";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";
const stylesSx = {
  buttonAlignForRemove: {
    padding: '32px !important',
  },
  bodyForRemove: {
    padding: '26px 24px 0px 24px !important',
    marginTop: '0px !important',
  },
};

const QuestionReport = ({ idContextTest }) => {
  const { userType } = useContext(UserTypeContext);
  const [isDataLoaded, setisDataLoaded] = useState(false);
  const history = useNavigate();
  const [reportedData, setreportedData] = useState([]);
  const [reportedDataType, setreportedDataType] = useState("Unresolved");
  const [isModalOpen, setisModalOpen] = useState(false);
  const [dataForModal, setdataForModal] = useState({});
  const [showAction, setShowAction] = useState(true);
  const [valueReport, setValueReport] = useState({ name: "Unresolved" });
  const [IsOpenConfirmDailog, setIsOpenConfirmDailog] = useState(false);
  const confirmDailogState = {};
  const confirmDailogType = "";
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState({});
  useEffect(() => {

    getReportedData();
  }, [reportedDataType]);
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await getReportedData();
      } catch (error) {
        setisDataLoaded(true);
      } finally {
        setisDataLoaded(true);
      }
    }
    fetchAllData()
  }, []);
  const reportTypeHandler = (e, value) => {
    if (value) {
      setValueReport(value);
      setreportedDataType(value.name);

      if (value.name === "Accepted") {
        setShowAction(false);
      }
      if (value.name === "Rejected") {
        setShowAction(false);
      } else {
        setShowAction(true);
      }
    } else {
      setreportedDataType("");
      setShowAction(true);
      setValueReport({});
    }
  };

  const getReportedData = async () => {

    var reportdata = {
      reportStatus: reportedDataType,
    };
    try {
      const reporteddataResponse = await getQuestionReportResponse(reportdata);

      if (reporteddataResponse.data.data.length > 0) {


        setreportedData(reporteddataResponse.data.data);
        setShowAction(
          reporteddataResponse.data.data.some(
            (e) => e.reportStatus === "Unresolved"
          )
        );
      } else {
        setreportedData([]);
      }
    } catch (error) {
      console.log(error);
    }

  };


  const openViewModal = (value) => {
    setdataForModal(value);
    setisModalOpen(true);
  };
  const closeModal = () => {
    setisModalOpen(false);
  };

  const handleOpen = (obj = {}) => {
    setComment({ ...obj, admincomments: "" });
    setOpen(true);
  };

  const handleClose = () => {
    setComment({});
    setOpen(false);
  };


  const resolveQuestion = async (value, type) => {
    var resolveData = {
      questionreportid: value.id,
      reportStatus: type,
    };

    try {
      await updateQuestionReportResponse(resolveData);
      await getReportedData();
      setreportedDataType("");
      setValueReport({});
      await NotificationManager.success(
        `This report is marked as ${type}ed`,
        "Success",
        10000
      );
      setIsOpenConfirmDailog(false);
    } catch (error) {
      console.log(error);
    }
  };
  const gotoQuestionReport = (questionId) => {
    history("/questions/" + questionId);
  };

  const reportType = [
    { name: "Unresolved" },
    { name: "Accepted" },
    { name: "Rejected" },
  ];
  const closeButton = {
    position: "absolute",
    right: "7px",
    top: "12px",
    color: "grey",
  };

  const btnGreen = {
    color: "#fff",
    backgroundColor: "#2AD156",
    border: "none",
    padding: "7px 11px 7px 11px",
    float: "right",
    marginRight: "17px",
    marginBottom: "15px",
  };
  const closeModalBtn = {
    color: "#01313C",
    backgroundColor: "#fff",
    border: " 1px solid #A3BCD5",
    marginBottom: "15px",
  };


  const handleSaveComment = async (e) => {
    if (comment.admincomments === "" || !comment.admincomments) {
      return NotificationManager.error(
        "Please fill all the mandatory fields",
        "Error",
        10000
      );
    }
    try {
      await updateQuestionReportResponse(comment);
      if (comment.reportStatus === "Accepted") {
        NotificationManager.success(
          "Question Report Accepted",
          "Success",
          10000
        );
      }
      if (comment.reportStatus === "Rejected") {
        NotificationManager.success(
          "Question Report Rejected",
          "Success",
          10000
        );
      }

      const newData = [...reportedData].filter(
        (d) => d.id !== comment.questionreportid
      );
      setreportedData(newData);
      handleClose();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className="section-wrapper">
        <div className="container w1200 flex-to-footer">
          <div className="height_adjust ">
            {!isDataLoaded ? (
              <div className="row padding_80 text-center">
                <CircularProgress />
              </div>
            ) : (
              <>
                {userType === "Admin" ? (
                  <Container
                    component={Paper}
                    className="allignmentFix"
                  >
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12 }}>
                        {/* //<DialogTitle id="customized-dialog-title" className="admindailog_title" style={headername}>Reported Questions</DialogTitle> */}
                        <h2 className="fs-semi-bold fs-30 f-color">
                          Reported Questions
                        </h2>
                      </Grid>
                      <Grid size={{ xs: 12, md: 4 }} >
                        <Typography gutterBottom>Resolution Status</Typography>
                        <FormControl fullWidth variant="outlined">
                          <Autocomplete
                            autoSelect
                            id="combo-box-demo"
                            options={reportType}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Select Resolution Status"
                              />
                            )}
                            value={valueReport}
                            onChange={(e, value) => reportTypeHandler(e, value)}
                          />
                        </FormControl>
                      </Grid>
                      <TableContainer>
                        <Table aria-label="collapsible table">
                          <TableHead>
                            <TableRow>
                              {/* <TableCell align="left">Name</TableCell> */}
                              <TableCell align="left" className="pl-0">
                                Question
                              </TableCell>
                              <TableCell align="left" className="nowrap-white">
                                Reported Date
                              </TableCell>
                              <TableCell
                                align="center"
                                className="nowrap-white"
                              >
                                Resolution Status
                              </TableCell>
                              <TableCell
                                align="center"
                                className="nowrap-white"
                              >
                                Reported By
                              </TableCell>
                              <TableCell
                                align="center"
                                className="nowrap-white"
                              >
                                Question Id
                              </TableCell>
                              <TableCell align="center">View</TableCell>
                              {/* {!showAction && <TableCell align="center">Action</TableCell>} */}
                              {/* {reportOnChange ?
                                                                    <> */}
                              {showAction ? (
                                <>
                                  <TableCell align="right">Action</TableCell>
                                </>
                              ) : (
                                ""
                              )}
                              {/* </>
                                                                    :
                                                                    <>
                                                                    </>
                                                                } */}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {reportedData.length !== 0 ? (
                              reportedData.map((value, index) => {
                                if (index === 0) {
                                }
                                return (
                                  <TableRow key={index}>
                                    {/* <TableCell >
                                                                            {
                                                                                (value.user.firstName ? value.user.firstName : "")
                                                                                + " " + (value.user.MiddleInitial ? value.user.MiddleInitial : "")
                                                                                + " " + (value.user.lastName ? value.user.lastName : "")
                                                                            }
                                                                        </TableCell> */}
                                    <TableCell
                                      size="small"
                                      className="cp pl-0 link-colour"
                                      onClick={() =>
                                        history(
                                          "/questions/" + value.questionId
                                        )
                                      }
                                    >
                                      {value.question.questionDesc}
                                      {/* <Link href={"https://" + window.location.host + "/questions/" + value.questionId} variant="body1" target="_blank">
                                                                            {(value.question.questionDesc)}
                                                                            </Link> */}
                                      {/* <NavLink to={`questions/${value.questionId}`}>{(value.question.questionDesc)}</NavLink> */}
                                    </TableCell>
                                    <TableCell>
                                      {/* {value.createdAt
                                        ? moment(value.createdAt).format("LLL")
                                        : ""} */}
                                      {value.createdAt
                                        ? DateTime.fromISO(
                                          value.createdAt
                                        ).toFormat("LLLL d, yyyy t")
                                        : ""}
                                    </TableCell>
                                    <TableCell>
                                      {value.reportStatus
                                        ? value.reportStatus
                                        : ""}
                                    </TableCell>
                                    <TableCell>
                                      <Link
                                        href={
                                          "https://" +
                                          window.location.host +
                                          "/candidate/profile/" +
                                          value.user.id
                                        }
                                        variant="body1"
                                        target="_blank"
                                      >
                                        {(value.user.firstName
                                          ? value.user.firstName
                                          : "") +
                                          " " +
                                          (value.user.MiddleInitial
                                            ? value.user.MiddleInitial
                                            : "") +
                                          " " +
                                          (value.user.lastName
                                            ? value.user.lastName
                                            : "")}
                                      </Link>
                                    </TableCell>
                                    <TableCell>{value.question.id}</TableCell>
                                    <TableCell>
                                      <Button
                                        onClick={(e) => openViewModal(value)}
                                      >
                                        <VisibilityIcon />
                                      </Button>
                                      {/* <Button onClick={(e) => resolveQuestion(value)}>Resolved</Button> */}
                                    </TableCell>
                                    {/* <TableCell>
                                                                            {value.reportStatus ==='Resolved' 
                                                                            ?
                                                                            null
                                                                             : 
                                                                             <Button onClick={(e) => resolveQuestion(value)}>Resolve</Button>
                                                                             }
                                                                        </TableCell> */}
                                    {value.reportStatus === "Accepted" ||
                                      value.reportStatus === "Rejected" ? null : (
                                      <>
                                        <TableCell>
                                          {/* <Button onClick={(e) => openConfirmDailog(value,"Accepted")}>Accept</Button> */}
                                          <Button
                                            onClick={() =>
                                              handleOpen({
                                                questionreportid: value.id,
                                                reportStatus: "Accepted",
                                              })
                                            }
                                          >
                                            Accept
                                          </Button>
                                        </TableCell>
                                        <TableCell>
                                          {/* <Button onClick={(e) => openConfirmDailog(value,"Rejected")}>Reject</Button> */}
                                          <Button
                                            onClick={() =>
                                              handleOpen({
                                                questionreportid: value.id,
                                                reportStatus: "Rejected",
                                              })
                                            }
                                          >
                                            Reject
                                          </Button>
                                        </TableCell>
                                      </>
                                    )}
                                  </TableRow>
                                );
                              })
                            ) : (
                              <Typography gutterBottom>
                                NO DATA FOUND
                              </Typography>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Container>
                ) : userType === "" ? (<div className="row padding_80 text-center">
                  <p className="fs-semi-bold fs-40 f-color">
                    Loading...
                  </p>
                </div>) : (
                  <UnauthorizedAccess />
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <Dialog
        onClose={closeModal}
        aria-labelledby="customized-dialog-title"
        open={isModalOpen}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <Grid size={{ xs: 12 }}>
          <div className="Recruiter_Private_Skill_Modal">
            <DialogTitle
              id="customized-dialog-title"
              className="admindailog_title_modal"
              onClose={closeModal}
            >
              Reported Question
              <IconButton
                aria-label="close"
                style={closeButton}
                onClick={closeModal}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
          </div>
        </Grid>
        <DialogContent className="userlist_dailog_content">
          <p
            className="fs-semi-bold fs-18 f-color cp"
            onClick={(e) => gotoQuestionReport(dataForModal.questionId)}
          >
            {dataForModal.question
              ? "Q: " + dataForModal.question.questionDesc
              : ""}
          </p>
          <div className="answer-set-container-question-report">
            {dataForModal.answer
              ? dataForModal.answer.map((item, index) => (

                <div className="answer-set-list-questionreport mb_12 radiobtn-questionreport ">
                  <div>
                    <FormControlLabel
                      value="disabled"
                      checked={dataForModal.usertestquestionanswer.find(
                        (el) => el.answerId === item.AnswerId
                      )}
                      control={
                        dataForModal.answertype.code === "SingleChoice" ? (
                          <Radio />
                        ) : (
                          <Checkbox />
                        )
                      }
                    />
                    <span className="fs-regular fs-18 f-color">
                      {item.answerText}
                    </span>
                  </div>
                  <div>
                    <span>
                      {item.isCorrect ? (
                        <>
                          <p className="fs-semi-bold fs-16 f-color">
                            Correct Answer
                          </p>
                        </>
                      ) : null}
                    </span>
                  </div>
                </div>
              ))
              : null}
            {/* <Typography gutterBottom></Typography> */}
            <p className="fs-semi-bold fs-18 f-color mb_10">
              Question Report Description
            </p>
            <Typography>
              {dataForModal.description ? dataForModal.description : null}
            </Typography>
          </div>
        </DialogContent>

        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" color="primary" onClick={closeModal}>
              Close
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
      <Dialog
        open={IsOpenConfirmDailog}
        onClose={() => setIsOpenConfirmDailog(false)}
        aria-labelledby="customized-dialog-title"
      >
        <DialogContent
          className="removemodal_responsive"
          sx={stylesSx.bodyForRemove}
        >
          <div className="text-center fs-semi-bold f-color fs-18">
            {confirmDailogType === "Accepted"
              ? "Do you want to resolve this report by marking the candidate's answer as correct?"
              : "Do you want to reject this report?"}
          </div>
        </DialogContent>
        <DialogActions
          className="responsiveRemove_Modal_button"
          sx={stylesSx.buttonAlignForRemove}
        >
          <div className="remove_modal">
            <button
              type="button"
              className="btn_remove btn-skill cp"
              onClick={() => setIsOpenConfirmDailog(false)}
            >
              No
            </button>
            <button
              type="button"
              className="btn2 btn-green ml_5 cp"
              onClick={(e) => {
                resolveQuestion(confirmDailogState, confirmDailogType)
                handleOpen()
              }
              }

            >
              Yes
            </button>
          </div>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: "500px",
          },
        }}
      >
        <DialogContent className="dialogContent">
          <Typography gutterBottom>Comment *</Typography>
          <TextareaAutosize
            className="textareaComment"
            type="text"
            placeholder="Enter Comment"
            value={comment.admincomments}
            onChange={(e) =>
              setComment({ ...comment, admincomments: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions className="btnAction">
          <Button onClick={handleClose} style={closeModalBtn}>
            cancel
          </Button>
          <Button onClick={handleSaveComment} style={btnGreen}>
            {comment.reportStatus === "Accepted" ? "accept" : "reject"}
          </Button>
        </DialogActions>
      </Dialog>

      <NotificationContainer />
    </>
  );
};

export default QuestionReport;

